import { render, staticRenderFns } from "./PacketPill.vue?vue&type=template&id=5a4e771d&scoped=true&"
import script from "./PacketPill.vue?vue&type=script&lang=ts&"
export * from "./PacketPill.vue?vue&type=script&lang=ts&"
import style0 from "./PacketPill.vue?vue&type=style&index=0&id=5a4e771d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a4e771d",
  null
  
)

export default component.exports